import React from "react";
import { FaShareAlt, FaSave, FaPlay } from "react-icons/fa";

const FinalScreen = () => {
  const handleBackToTrail = () => {
    console.log("");
  };
  return (
    <div className="relative w-full h-screen bg-gradient-to-bl from-blue-50 to-gray-100 flex flex-col items-center">
      {/* Top Navigation */}
      {/* <div className="w-full flex justify-between px-8 py-4 text-gray-700 font-semibold">
        <span>FINAL SCREEN</span>
        <nav className="flex gap-6">
          <a href="#" className="hover:underline">
            Home
          </a>
          <a href="#" className="hover:underline">
            Chat
          </a>
          <a href="#" className="hover:underline">
            Community
          </a>
          <a href="#" className="hover:underline">
            Resources
          </a>
          <a href="#" className="hover:underline">
            History
          </a>
        </nav>
      </div> */}

      {/* Background Lines for Situations & Behaviors */}
      <div className="absolute w-full h-full top-0 left-0">
        <svg className="absolute w-full h-full">
          <line
            x1="20%"
            y1="40%"
            x2="50%"
            y2="50%"
            stroke="gray"
            strokeWidth="1"
          />
          <line
            x1="80%"
            y1="30%"
            x2="50%"
            y2="50%"
            stroke="gray"
            strokeWidth="1"
          />
          <line
            x1="30%"
            y1="70%"
            x2="50%"
            y2="50%"
            stroke="gray"
            strokeWidth="1"
          />
        </svg>

        {/* Situation/Behavior Labels */}
        <div className="absolute top-[38%] left-[18%] bg-orange-400 text-white px-3 py-1 rounded-full shadow-md">
          Security Breach
        </div>
        <div className="absolute top-[28%] right-[15%] bg-orange-400 text-white px-3 py-1 rounded-full shadow-md">
          Executive Decision Making
        </div>
        <div className="absolute bottom-[25%] left-[25%] bg-orange-400 text-white px-3 py-1 rounded-full shadow-md">
          Tech Obstacle
        </div>
        <div className="absolute bottom-[20%] right-[20%] bg-orange-400 text-white px-3 py-1 rounded-full shadow-md">
          Budget Cut
        </div>
      </div>

      {/* ID Card (Centered) */}
      <div className="relative z-10 w-[40%] mt-24 flex justify-center items-center p-4 animate-fadeIn">
        <div className="bg-white shadow-inner shadow-gray-500 border border-gray-300 rounded-2xl w-[60%]">
          {/* Profile Section */}
          <div className="relative flex items-center bg-gradient-to-tr from-slate-300 via-white to-slate-400 p-3 rounded-t-2xl">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLXuM2b4djVbMt63hftHrWFFMeQmccyytKlQ&s"
              alt="Profile"
              className="w-36 h-48 object-cover rounded-2xl"
            />
            <div className="flex flex-col absolute bottom-4 left-40 justify-end pl-4">
              <h2 className="text-lg text-black font-semibold">
                Samantha Jones
              </h2>
              <p className="text-md text-gray-500">Chief Technology Officer</p>
            </div>
            <div className="absolute top-2 right-2 flex gap-2">
              <button className="bg-white p-2 rounded-full shadow-md">
                <FaShareAlt className="text-gray-600" />
              </button>
              <button className="bg-white p-2 rounded-full shadow-md">
                <FaSave className="text-gray-600" />
              </button>
            </div>
          </div>

          {/* Attributes Section */}
          <div className="bg-orange-400 text-white font-semibold text-md flex justify-center gap-2 py-2">
            <span>▫️ Integrity</span>
            <span>▫️ Empathy</span>
            <span>▫️ Leadership</span>
          </div>

          {/* Content Sections */}
          <div className="p-2">
            <div className="rounded-xl">
              {/* Success Indicators */}
              <div className="p-3 w-[95%] mx-auto">
                <h3 className="text-md text-black font-semibold">
                  Success Indicators
                </h3>
                <p className="text-sm text-gray-700 mt-1">
                  Decision making at executive level - Growing expertise in
                  cyber security - Mentoring - Learning
                </p>
              </div>

              {/* Traits Section */}
              <div className="p-3 border-t border-gray-400 w-[95%] mx-auto">
                <h3 className="text-md text-black font-semibold">Traits</h3>
                <div className="flex gap-2 mt-2">
                  <span className="bg-orange-400 text-white text-sm px-3 py-1 rounded-md font-semibold">
                    Achievement
                  </span>
                  <span className="bg-orange-400 text-white text-sm px-3 py-1 rounded-md font-semibold">
                    Balance
                  </span>
                  <span className="bg-orange-400 text-white text-sm px-3 py-1 rounded-md font-semibold">
                    Creative
                  </span>
                </div>
              </div>

              {/* Quote Section */}
              <div className="p-3 border-t border-gray-400 w-[95%] mx-auto">
                <div className="text-md italic text-gray-700">
                  "It’s not about ideas. It’s about making ideas happen." –
                  Scott Belsky
                </div>
              </div>

              {/* Audio Section */}
              <div className="p-3 rounded-b-xl">
                <div className="w-[95%] mx-auto bg-orange-100 p-3 flex items-center gap-4 rounded-xl shadow-md">
                  <button className="w-12 h-12 text-black text-xl flex items-center justify-center rounded-full">
                    <FaPlay />
                  </button>

                  <div className="flex-1 flex items-center gap-1">
                    {[...Array(20)].map((_, i) => (
                      <div
                        key={i}
                        className="w-1 bg-gray-700 rounded-full"
                        style={{ height: `${Math.random() * 20 + 10}px` }}
                      ></div>
                    ))}
                  </div>

                  <img
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLXuM2b4djVbMt63hftHrWFFMeQmccyytKlQ&s"
                    alt="User"
                    className="w-12 h-12 rounded-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Call-to-Action Button */}
      <button className="absolute top-[20%] right-[5%] bg-white border border-gray-400 px-4 py-2 rounded-lg shadow-md hover:bg-gray-200">
        See what's ahead →
      </button>

      {/* Back to Trail Link */}
      <button
        // href="#"
        onClick={handleBackToTrail}
        className="absolute bottom-[10%] left-[5%] text-teal-600 hover:underline"
      >
        ← Back to Trail
      </button>
    </div>
  );
};

export default FinalScreen;
